(() => {
  const SEL = {
    box: '[data-termsbox], #termsbox_id',
    stamp: '[data-termsstamp]',
  };

  const HTML_CLASS_BLOCK = 'lk-terms-not-agreed';
  const ATTR_KEY = 'Customer agreed to terms';

  function nowStamp() {
    return new Date().toISOString();
  }

  function getAllBoxes() {
    return Array.from(document.querySelectorAll(SEL.box));
  }

  function anyChecked() {
    const boxes = getAllBoxes();
    return boxes.some(b => b instanceof HTMLInputElement && b.checked);
  }

  function setHtmlBlocked(blocked) {
    document.documentElement.classList.toggle(HTML_CLASS_BLOCK, blocked);
  }

  function setAllBoxes(checked) {
    getAllBoxes().forEach(b => { if (b instanceof HTMLInputElement) b.checked = checked; });
  }

  function setAllStamps(value) {
    document.querySelectorAll(SEL.stamp).forEach(el => { el.value = value || ''; });
  }

  async function setCartAttribute(valueOrEmpty) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { [ATTR_KEY]: valueOrEmpty } })
      });
    } catch (_) {
      // UI всё равно блокирует через CSS
    }
  }

  async function applyStateFromBox(box) {
    const checked = box.checked;
    const value = checked ? nowStamp() : '';

    // синхронизируем все чекбоксы (drawer/page)
    setAllBoxes(checked);

    // hidden inputs (backup)
    setAllStamps(value);

    // CSS-блокировка
    setHtmlBlocked(!checked);

    // фиксируем на сервере (важно для dynamic checkout)
    await setCartAttribute(value);
  }

  function init() {
    // стартовое состояние: если ни один чекбокс не отмечен — блокируем
    setHtmlBlocked(!anyChecked());
  }

  // Делегирование — переживает перерисовку drawer/page
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.matches(SEL.box)) return;
    applyStateFromBox(t);
  });

  // На всякий: если тема ререндерит DOM, состояние не потеряется
  let timer = null;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(() => setHtmlBlocked(!anyChecked()), 50);
  };

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
})();
